const OctokitDefaults = {
    owner: "brandongregoryscott",
    repo: "beets",
};

export { OctokitDefaults };
